export interface RentDurationPreset {
  id: string;
  label: string;
  months?: number;
  days?: number;
  /** Najam bez završetka — traje do otkaza. */
  openEnded?: boolean;
}

/** Brzi odabir trajanja: kratkoročni najam se mjeri danima, dugoročni mjesecima. */
export const RENT_DURATION_PRESETS: RentDurationPreset[] = [
  { id: "7d", label: "7 dana", days: 7 },
  { id: "15d", label: "15 dana", days: 15 },
  { id: "1m", label: "1 mjesec", months: 1 },
  { id: "3m", label: "3 mjeseca", months: 3 },
  { id: "6m", label: "6 mjeseci", months: 6 },
  { id: "12m", label: "12 mjeseci", months: 12 },
  { id: "24m", label: "24 mjeseca", months: 24 },
  { id: "36m", label: "36 mjeseci", months: 36 },
  { id: "open", label: "Neodređeno", openEnded: true },
];
